import { useOrganizationBilling } from "../../api/Organizations";
import { ContentTitle } from "../../layout/ContentLayout";

const Billing = ({ organizationId }) => {
  return <ContentTitle>Billing</ContentTitle>;
};

export default Billing;
